// The tracks a cover's vocals are made of. One voice: convertedUrl. Several
// voices: each voice's own full track, mixed by voiceTimes. The jammer keeps
// no vocals-only mix for those, and convertedUrl is just whichever voice's
// track finished last (the v2 webhook's vocal-complete overwrites it), so
// it's one voice singing the whole song. Each voice's track sits at the same
// path with its own urlParam ("…/vocal:<urlParam>/finished/audio.mp3").
// When the jammer exports a vocals-only mix and convertedUrl points at it,
// this stops being needed.

/* eslint-disable @typescript-eslint/no-explicit-any */

export type VoiceTrack = { voice: string; url: string };
export type VoiceSegment = { voice: string; start: number; end: number };

const VOCAL_PATH = /\/vocal:[^/]+\//;

export function voiceTracksOf(
  conversion: any,
): { tracks: VoiceTrack[]; segments: VoiceSegment[] } | null {
  const models: any[] = conversion?.models ?? [];
  const segments: VoiceSegment[] = conversion?.voiceTimes ?? [];
  const base: string = conversion?.convertedUrl ?? "";
  if (models.length < 2 || !segments.length || !VOCAL_PATH.test(base)) {
    return null;
  }
  const tracks = models.map((m) => ({
    voice: m.urlParam as string,
    url: base.replace(VOCAL_PATH, `/vocal:${m.urlParam}/`),
  }));
  return { tracks, segments };
}
